<!--  -->
<template>
  <div class="container">
    <div class="page_title">一线运动员在编</div>
    <!-- 年份选择器 -->
    <YearSelect
      :defaultValue="newYearData"
      :yearOptions="yearOptions"
      @changeYear="changeYear"
    ></YearSelect>
    <!-- 人员数 -->
    <div class="model_box_1">
      <img src="../../../assets/imgs/page/3.png" alt="" />
      <div class="value">
        <span class="num">直属事业单位</span>
        <span>{{athIetes.zsdwList}}</span>
        <span class="unit">人</span>
      </div>
    </div>
    <div class="model_box_1">
      <img src="../../../assets/imgs/page/3.png" alt="" />
      <div class="value">
        <span class="num">社会联办</span>
        <span>{{athIetes.shlbList}}</span>
        <span class="unit">人</span>
      </div>
    </div>
    <div class="model_box model_box_2">
      <div class="model_box_title">训练项目</div>
      <div class="model_box_content">
        <BlueBarChart :data="XLXMBarData"></BlueBarChart>
      </div>
      <div class="otherMore" @click="openDialog">其他></div>
    </div>
    <div class="model_box model_box_3">
      <div class="model_box_title">所属单位</div>
      <div class="model_box_content">
        <div class="echart_box"><PieChart :data="SSDWpieData"></PieChart></div>
        <div class="legend_box">
          <div class="item" v-for="v in SSDWpieData" :key="v.name">
            <div class="tag" :style="{ background: v.color }"></div>
            <div class="info">
              <span class="name">{{ v.name }}</span>
              <span class="value">{{ v.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="model_box model_box_4">
      <div class="model_box_title">年龄</div>
      <div class="model_box_content">
        <BlueBarChart :data="NLBarData"></BlueBarChart>
      </div>
    </div>
    <div v-if="showDialog" class="dialog-wrapper">
      <!-- <div class="dialog">
        <h2 class="dialog-title">对话框标题</h2>
        <p class="dialog-content">对话框内容</p>
        <button @click="closeDialog" class="dialog-button">关闭</button>
      </div> -->
      <div class="model_box model_box_2">
        <div class="tit">
          <div class="model_box_title">训练项目-其他</div>
          <div class="close" @click="closeDialog">X</div>
        </div>
        <div class="model_box_content">
          <BlueBarChart :data="XLXMOTHERBarData"></BlueBarChart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 绿色-柱状图
import GreenBarChart from '@/components/echarts/SingleBarChartGreen.vue'
// 蓝色-柱状图
import BlueBarChart from '@/components/echarts/SingleBarChartBlue.vue'
// 饼图
import PieChart from '@/components/echarts/PieChartWithoutLabel.vue'
// 接口数据
import { oneBigScreen } from '@/api/dataManage'
import { getTest } from '@/api/dataUser'
import { Message } from 'element-ui'
export default {
  components: { GreenBarChart, BlueBarChart, PieChart },
  data() {
    return {
      showDialog: false,
      
      athIetes: {},
      // 年份选择器
      yearValue: '',
      yearOptions: [
        {
          value: '2026',
          label: '2026年'
        },
        {
          value: '2025',
          label: '2025年'
        },
        {
          value: '2024',
          label: '2024年'
        },
        {
          value: '2023',
          label: '2023年'
        },
        {
          value: '2022',
          label: '2022年'
        },
        {
          value: '2021',
          label: '2021年'
        },
        {
          value: '2020',
          label: '2020年'
        },
        {
          value: '2019',
          label: '2019年'
        }
      ],
      GWDJBarData: {

      },
      XLpieData: [
        
      ],
      XWpieData: [
        
      ],
      XBpieData: [
       
      ],
      NLBarData: {
       
      },
      ZZMMBarData: {  
      
      },
      newYearData:'2023',
      zsdwList:"",
      shlbList:"",
      XLXMBarData:[],
      XLXMOTHERBarData:[],
      SSDWpieData:[],
      NLBarData:[]
    }
  },
  computed: {},
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    closeDialog() {
      this.showDialog = false;
    },
    changeYear(val) {
      this.yearValue = val
      console.log('🚀 ~ changeYear ~ val:', val);
      this.newYearData = val;
      this.researchList();
      
    },
    getUser(){
      const pageForm = {
        id:1
      };
      let pageableForm = { ...pageForm};
      getTest(pageableForm)
        .then((res) => {
          console.log('res', res)
          if (res.code == 0) {
            console.log("res",res);
          } else {
            Message({
              type: 'warning',
              message: res.msg,
            })
          }
        })
        .catch((error) => {
          console.log('catch', error)
        })
    },
    researchList() {
      const pageForm = {
        // page: this.page,
        // pageSize: this.pageSize,
        // taskTypeId: this.taskTypeId,
        year:this.newYearData
      };
      let pageableForm = { ...pageForm};
      oneBigScreen(pageableForm)
        .then((res) => {
          console.log('res', res)
          if (res.code == 0) {
            this.athIetes = res.data
            // 直属事业单位数量
            this.zsdwList = res.data.zsdwList;
            // 社会联办数量
            this.shlbList = res.data.shlbList;
            //训练项目
            this.XLXMBarData = res.data.XLXMBarData;
            //训练项目(其他)
            this.XLXMOTHERBarData = res.data.XLXMOTHERBarData;
            //所属单位
            this.SSDWpieData = res.data.SSDWpieData;
            //年龄
            this.NLBarData = res.data.NLBarData;
            
            // this.GWDJBarData = res.data.GWDJBarData;
            // 学历
            // this.XLpieData = res.data.XLpieData;
            // 学位
            // this.XWpieData = res.data.XWpieData;
            // 性别
            // this.XBpieData = res.data.XBpieData;
            // 年龄
            // this.NLBarData = res.data.NLBarData;
            // 政治面貌
            // this.ZZMMBarData = res.data.ZZMMBarData;
          } else {
            // Message(res.msg);

            Message({
              type: 'warning',
              message: res.msg,
            })
          }
        })
        .catch((error) => {
          console.log('catch', error)
        })
    },
  },
  created() {
    // this.researchList()
    this.getUser()
  },
  mounted() {},
  destroyed() {}
}
</script>
<style lang="less" scoped>
// ------------------布局相关
.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: space-between;
}
.model_box {
  height: calc(33.3% - 10px);
  background: #fff;
  border-radius: 5px;
  .model_box_title {
    font-size: 15px;
    height: 30px;
    line-height: 33px;
    font-weight: bold;
    padding-left: 20px;
    letter-spacing: 2px;
  }
  .model_box_content {
    height: calc(100% - 30px);
    width: 100%;
  }
}
// 人员数
.model_box_1 {
  height: calc(15% - 10px);
  background: #fff;
  border-radius: 5px;
  width: calc(50% - 7px);
  display: flex;
  // flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-left:100px;
  margin-bottom:20px;
  img {
    margin-bottom: 10px;
    margin-right: 10px;
    width: 55px;
  }
  .value {
    .num{
      font-size: 15px;
      margin-left:10px;
      margin-right:10px;
    }
    font-size: 24px;
    font-weight: bold;
    .unit {
      font-size: 14px;
      font-weight: 400;
      margin-left: 2px;
    }
  }
}
// 岗位等级
.model_box_2 {
  width: calc(100% - 7px);
  position:relative;
  .otherMore{
    position:absolute;
    bottom:15px;
    right:10px;
    font-size:15px;
  }
  .tit{
    display:flex;
    justify-content: space-between;
    .close{
      margin-top:5px;
      margin-right:10px;
    }
  }
}
.model_box_3{
  width: calc(30% - 7px);
}
.model_box_4 {
  width: calc(70% - 7px);
}


.model_box_3,
.model_box_4 {
  height:45%;
  .model_box_content {
    // display: flex;
    padding-right: 20px;
    .echart_box {
      width: 100%;
      height: 50%;
    }
    .legend_box {
      width: 100%;
      // height: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;
      .item {
        width: calc(50% - 10px);
        height: calc(50% - 20px);
        background: #f8fafd;
        border-radius: 8px;
        display: flex;
        // flex-direction: column;
        justify-content: space-evenly;
        padding: 5px 0px 5px 10px;
        .tag {
          width: 20px;
          height: 4px;
          border-radius: 2px;
          margin-top:10px;
        }
        .info {
          font-weight: 700;
          display: flex;
          align-items: center;
          .name {
            font-size: 13px;
            width: 75px;
          }
          .value {
            font-size: 18px;
          }
        }
      }
    }
  }
}

.dialog-wrapper {
  padding:20px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
